var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.baseNameList),function(item,index){return _c('v-list-tile',{key:index},[_c('v-list-tile-content',[_vm._v(_vm._s(item))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }